import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

export interface Beneficio {
    descuento: string;
    titulo: string;
    desc: string;
    iconKey: string;
    /** Ruta del servicio dentro del portal de servicios legales, sin barra inicial. */
    ruta?: string;
}

@Component({
    selector: 'app-benefits',
    templateUrl: './benefits.component.html',
    styleUrls: ['./benefits.component.scss']
})
export class BenefitsComponent {

    @Input() beneficios: Beneficio[] = [
        { descuento: '-20% Descuento', titulo: 'Sucesiones y herencias',   desc: 'Te ayudamos a tramitar una herencia de principio a fin.',            iconKey: 'sucesiones',   ruta: 'servicios/sucesiones-y-herencias/tramitacion-de-herencia' },
        { descuento: '-20% Descuento', titulo: 'Vehículos',                desc: 'Gestionamos el cambio de titularidad de tu vehículo.',              iconKey: 'vehiculos',    ruta: 'servicios/vehiculos/gestoria-cambio-nombre-vehiculos' },
        { descuento: '-20% Descuento', titulo: 'Pensiones',                desc: 'Te ayudamos a tramitar tu pensión de jubilación.',                  iconKey: 'pensiones',    ruta: 'servicios/laboral/tramitacion-de-jubilacion' },
        { descuento: '-20% Descuento', titulo: 'Vivienda',                 desc: 'Certificado energético, cédula de habitabilidad e informe técnico.', iconKey: 'certificados', ruta: 'servicios/vivienda' }
    ];
    @Input() descuentoGlobal: string = '-20% por ser cliente onLygal';
    @Input() subtitulo: string = 'Accede a servicios legales y de gestoría a precio preferente';

    constructor(private router: Router) {}

    get items(): Beneficio[] {
        return (this.beneficios || []).slice(0, 4);
    }

    irA(link: string): void {
        this.router.navigate([link]);
    }

    /** "Ver todos los servicios" lleva al portal de servicios legales, no al listado interno. */
    verTodosLosServicios(): void {
        window.open(environment.serviciosLegalesUrl, '_blank', 'noopener');
    }

    /**
     * URL del servicio en el portal de servicios legales. El dominio sale de
     * environment.serviciosLegalesUrl, que ya termina en barra, y la ruta del propio beneficio.
     */
    urlDelBeneficio(beneficio?: Beneficio): string {
        if (!beneficio) {
            return environment.serviciosLegalesUrl;
        }
 
        return beneficio.ruta? environment.serviciosLegalesUrl + beneficio.ruta: '';
    }

    /**
     * Abre el servicio en una pestaña nueva. Los beneficios sin ruta siguen llevando al listado
     * interno, para no dejar la tarjeta sin acción si se añade una sin enlace externo.
     */
    verBeneficio(beneficio?: Beneficio): void {
        const url = this.urlDelBeneficio(beneficio);
        if (url) {
            window.open(url, '_blank', 'noopener');
            return;
        }
        this.router.navigate(['/benefits']);
    }

    iconForBenefit(b: Beneficio, idx: number): string {
        const base = 'resources/assets/images/main-page/';
        const map: { [k: string]: string } = {
            calendar:      'calendar-edit.svg',
            'calendar-edit': 'calendar-edit.svg',
            sucesiones:    'calendar-edit.svg',
            herencias:     'calendar-edit.svg',
            car:           'car.svg',
            coche:         'car.svg',
            vehiculo:      'car.svg',
            vehiculos:     'car.svg',
            money:         'moneys.svg',
            moneys:        'moneys.svg',
            pension:       'moneys.svg',
            pensiones:     'moneys.svg',
            book:          'archive-book.svg',
            archive:       'archive-book.svg',
            certificado:   'archive-book.svg',
            certificados:  'archive-book.svg',
            vivienda:      'archive-book.svg'
        };
        const defaults = ['calendar-edit.svg', 'car.svg', 'moneys.svg', 'archive-book.svg'];
        const key = ((b && b.iconKey) || '').toLowerCase().trim();

        for (const k of Object.keys(map)) {
            if (key && key.indexOf(k) !== -1) { return base + map[k]; }
        }
        return base + (defaults[idx % defaults.length] || 'bag-2.svg');
    }
}
